import { useRef } from "react";
import useAnimateWhileVisible from "../../hooks/useAnimateWhileVisible";
import "./SkeletonGrid.css";

const SkeletonCard = ({ delay = 0 }) => (
  <div className="sk-card" style={{ animationDelay: `${delay}ms` }}>
    <div className="sk-image shimmer" />
    <div className="sk-body">
      <div className="sk-line shimmer" style={{ width: "75%" }} />
      <div className="sk-line shimmer" style={{ width: "90%", height: "10px", marginTop: "6px" }} />
      <div className="sk-line shimmer" style={{ width: "55%", height: "10px" }} />
      <div className="sk-footer">
        <div className="sk-price shimmer" />
        <div className="sk-btn shimmer" />
      </div>
    </div>
  </div>
);

// The shimmer runs only while the grid can be seen. A lazy rail far below
// the fold renders its skeleton long before anyone scrolls to it, and on
// the homepage that was 300 shimmers repainting offscreen, ~2.9 s of every
// 8 s on a mid-range phone (speed Phase 0, 2026-10-08).
const SkeletonGrid = ({ count = 4, className = "product-grid" }) => {
  const ref = useRef(null);
  const animate = useAnimateWhileVisible(ref);
  return (
    <div ref={ref} className={`${className}${animate ? "" : " sk-paused"}`}>
      {Array.from({ length: count }, (_, i) => (
        <SkeletonCard key={i} delay={i * 60} />
      ))}
    </div>
  );
};

export default SkeletonGrid;
